import * as React from "react";
import Shop from "../../_data/models/Shop";
import Meta from "../../_data/models/Meta";
import ReduxInfiniteScroll from 'redux-infinite-scroll';
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";
import ShopListItemContainer from "../container/ShopListItemContainer";
import {Map} from "immutable";


interface Props {
    items: Map<number, Shop>;
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
    errors: string[];
    filterByName: () => void;
}

const ShopListComponent = (props: Props) => {

    const {items, meta, loading, loadMore, filterByName} = props;


    return (
    <div>
        <div className="row expanded">
            <BreadcrumbsComponent>
                <li>Shops</li>
            </BreadcrumbsComponent>
            {/*<div className="medium-6 column">*/}
                {/*<div className="search-box mt-half mb-half">*/}
                    {/*<div className="pull-right search-box">*/}
                        {/*<input type="text" placeholder="Search" onChange={filterByName}  />*/}
                    {/*</div>*/}
                {/*</div>*/}
            {/*</div>*/}
        </div>

        <div className="row expanded">
            <div className="large-12 columns">
                <ReduxInfiniteScroll
                    holderType="ul"
                    className="list-block flex-container"
                    loadMore={() => loadMore(meta)}
                    elementIsScrollable={false}
                    loadingMore={loading}
                    showLoader={false}
                    threshold={200}>
                    {
                        items.toArray().map((shop) => {
                            return <ShopListItemContainer {...props} key={shop.id} shop={shop} />;
                        })
                    }
                </ReduxInfiniteScroll>

            </div>
        </div>
    </div>
    );
};

export default ShopListComponent;


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopListComponent.tsx